import { createContext } from "react";
import { ExternalPromoMedia, Promo } from "../../interfaces/promo";

export type PromoContextProps = {
  countryPromo? : Promo
  externalPreheaders: ExternalPromoMedia[]
  externalPopup: ExternalPromoMedia | null
  externalPromosLoaded: boolean
};

export const PromoContext = createContext<PromoContextProps>({} as PromoContextProps);

// export  PromoContext;
